import { render, staticRenderFns } from "./index-cool.vue?vue&type=template&id=4531c393"
import script from "./index-cool.vue?vue&type=script&lang=js"
export * from "./index-cool.vue?vue&type=script&lang=js"
import style0 from "./index-cool.vue?vue&type=style&index=0&id=4531c393&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\project\\yl\\yl-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4531c393')) {
      api.createRecord('4531c393', component.options)
    } else {
      api.reload('4531c393', component.options)
    }
    module.hot.accept("./index-cool.vue?vue&type=template&id=4531c393", function () {
      api.rerender('4531c393', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/head/index-cool.vue"
export default component.exports